import { DeviceWithCommunicationError, Header } from "components"
export const DeviceCommunicationError = () => {
 return (
  <div>
   <div className="z-10 relative">
    <Header />
   </div>
   <DeviceWithCommunicationError />
  </div>
 )
}
